import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Arrow Components
const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} bg-primary`}
      style={{
        ...style,
        display: "block",
        borderRadius: "50%",
        right: "10px",
        zIndex: 1,
      }}
      onClick={onClick}
    >
      ›
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} bg-primary`}
      style={{
        ...style,
        display: "block",
        background: "gray",
        borderRadius: "50%",
        left: "10px",
        zIndex: 1,
      }}
      onClick={onClick}
    >
      ‹
    </div>
  );
};

const SlickSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      src: "/images/assets/patients.jpeg",
      title: `PATIENTS`,
      caption: ` Get phlebotomy services from the comfort of your own home now.
                We follow industry- leading protocols for accurate processing,
                packaging and delivery of specimens to our laboratory for
                testing.`,
    },
    {
      src: "/images/assets/practictioners.jpeg",
      title: `PRACTICTIONERS`,
      caption: `We are your one stop shop for the collection, processing and
                delivery of specimens required for the diagnostic testing you
                prescribe. We offer a flexible option and e-health share that
                is, you can schedule to have our phlebotomist at your facility
                for either half day or whole sessions or we will be available on
                demand per draw.`,
    },
    {
      src: "/images/assets/medical-lab.jpeg",
      title: `HOSPITAL LABS`,
      caption: `  Reach out to our phlebotomist anytime you need specimens to be
                collected to and from our lab and we are more than willing to
                assist you.`,
    },
    {
      src: "/images/assets/corporate.jpeg",
      title: `CORPORATE BODY`,
      caption: ` Our mobile Concierge phlebotomists would be happy to assist your
                employees with specimen collection, processing, and delivery to
                our lab without distorting their work schedules. We can set a
                flexible site within or very close to your company without
                disrupting workflow. We can also assist with specimen collection
                and testing for pre- employment and annual employee screening.`,
    },
  ];

  return (
    <div className="container pt-2   my-8 ">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <h5 className="text-center pt-2 text-primary-emphasis fw-bold ">
              {slide.title}
            </h5>

            <img
              className="img-fluid col-lg-7 pt-1  col-sm-12  rounded mx-auto  "
              src={slide.src}
              alt={`Slide ${index + 1}`}
              //   style={{ width: "60%", borderRadius: "10px" }}
            />
            <br />
            <div className="card col-sm-12 col-lg-7  col-md- 5 mx-auto bg-warning-subtle">
              <p
                className="text-primary-emphasis container fs-5 "
                style={{ textAlign: "center", marginTop: "10px" }}
              >
                {slide.caption}
              </p>
            </div>
          </div>
        ))}
      </Slider>
      <br />
    </div>
  );
};

export default SlickSlider;
